module.exports = __webpack_public_path__ + "web/img/essence-en.5871a527.png";